import React, { useEffect, useState } from 'react';
import { verifyMagicToken } from '../utils/authUtils';
import { useAuth } from '../contexts/AuthContext';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
interface MagicLinkVerifyProps {
  token: string;
  onSuccess: () => void;
}
const MagicLinkVerify: React.FC<MagicLinkVerifyProps> = ({
  token,
  onSuccess
}) => {
  const [verifying, setVerifying] = useState(true);
  const [verified, setVerified] = useState(false);
  const {
    setAuthenticated
  } = useAuth();
  useEffect(() => {
    const verify = async () => {
      // Simulate network delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      const isValid = verifyMagicToken(token);
      setVerified(isValid);
      setVerifying(false);
      if (isValid) {
        setAuthenticated(true);
        // Redirect to main app after a short delay
        setTimeout(onSuccess, 1500);
      }
    };
    verify();
  }, [token, onSuccess, setAuthenticated]);
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4" data-id="element-105">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center" data-id="element-106">
        <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-107">
          Verifying Magic Link
        </h1>
        {verifying ? <div className="space-y-4" data-id="element-108">
            <div className="flex justify-center" data-id="element-109">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-110"></div>
            </div>
            <p className="text-gray-600" data-id="element-111">Verifying your magic link...</p>
          </div> : verified ? <div className="space-y-4" data-id="element-112">
            <div className="flex justify-center" data-id="element-113">
              <CheckCircleIcon className="h-16 w-16 text-green-500" data-id="element-114" />
            </div>
            <h2 className="text-xl font-semibold text-green-700" data-id="element-115">Success!</h2>
            <p className="text-gray-600" data-id="element-116">
              You've been successfully authenticated. Redirecting you to the
              app...
            </p>
          </div> : <div className="space-y-4" data-id="element-117">
            <div className="flex justify-center" data-id="element-118">
              <XCircleIcon className="h-16 w-16 text-red-500" data-id="element-119" />
            </div>
            <h2 className="text-xl font-semibold text-red-700" data-id="element-120">Invalid Link</h2>
            <p className="text-gray-600" data-id="element-121">
              This magic link is invalid or has expired. Please request a new
              one.
            </p>
            <div className="pt-4" data-id="element-122">
              <a href="/" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-123">
                Back to Login
              </a>
            </div>
          </div>}
      </div>
    </div>;
};
export default MagicLinkVerify;